// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"5cec60c4","256":"c3804276","407":"92b8976a","714":"0edf6fc2","818":"157ca995"}[chunkId] + ".css";
};